import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getActiveSystemNotices } from "./systemNoticesApi";
import SystemNoticeBanner from "./SystemNoticeBanner";
import MaintenanceOverlay from "./MaintenanceOverlay";
import ToastNotice from "./ToastNotice";

export default function SystemNoticesGate() {
    const { currentUser } = useSelector((state) => state.auth);

    const [activeNotices, setActiveNotices] = useState({ maintenance: null, banner: null, toast: null });
    const [toastVisible, setToastVisible] = useState(false);
    const [toastDismissedId, setToastDismissedId] = useState(null);

    useEffect(() => {
        let isMounted = true;

        async function refresh() {
            try {
                const data = await getActiveSystemNotices({ force: true });
                const notices = data && Array.isArray(data.notices) ? data.notices : [];

                const maintenance = notices.find((n) => n.type === "maintenance") || null;
                const banner = notices.find((n) => n.type === "banner") || null;
                const toast = notices.find((n) => n.type === "toast") || null;

                if (!isMounted) return;

                setActiveNotices({ maintenance, banner, toast });

                if (toast && toast.id !== toastDismissedId) {
                    setToastVisible(true);
                    const timeoutSeconds = toast.toast_timeout_seconds || 8;
                    if (window.__lakatoToastTimer) window.clearTimeout(window.__lakatoToastTimer);
                    window.__lakatoToastTimer = window.setTimeout(() => {
                        setToastVisible(false);
                        setToastDismissedId(toast.id);
                    }, timeoutSeconds * 1000);
                }
            } catch (e) {
                // best-effort
            }
        }

        refresh();
        const intervalId = window.setInterval(refresh, 15 * 1000);

        return () => {
            isMounted = false;
            if (intervalId) window.clearInterval(intervalId);
        };
    }, [toastDismissedId]);

    const isAdmin = !!(currentUser && currentUser.isAdmin === 1);

    return (
        <>
            {activeNotices.maintenance && !isAdmin ? <MaintenanceOverlay notice={activeNotices.maintenance} /> : null}
            <SystemNoticeBanner notice={activeNotices.banner} />
            {activeNotices.toast && toastVisible && activeNotices.toast.id !== toastDismissedId ? (
                <ToastNotice
                    notice={activeNotices.toast}
                    onClose={() => {
                        setToastVisible(false);
                        setToastDismissedId(activeNotices.toast.id);
                    }}
                />
            ) : null}
        </>
    );
}


